<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="addGroup"
          >添加群组</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          style="width:250px"
          v-model.trim="groupAppellation"
          placeholder="请输入群组名称"
          size="small"
          class="ipt mr10"
        ></el-input>

        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        :data="memberGroupList.records"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="groupAppellation"
          label="群组名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="relType"
          label="关联类型"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.relType === 'membercard'">会员卡</span>
            <span v-else>会员标签</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="groupBackgroundImg"
          label="身份背景图"
        >
          <template slot-scope="scope">
            <img
              style="width:100%;"
              :src="scope.row.groupBackgroundImg"
              v-if="scope.row.groupBackgroundImg"
              alt=""
            />
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="profitValue"
          label="专属权益"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.profitValue !== ''">
              商品专享{{ scope.row.profitValue }}折
            </div>
            <div
              v-if="
                scope.row.shareProfitValue !== '' &&
                  scope.row.shareProfitValue !== null
              "
            >
              分销权益 {{ scope.row.shareProfitValue }}折
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="编辑" placement="top">
                <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="memberGroupList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      groupAppellation: "",
      isOutputing: false,
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: mapGetters(["memberGroupList", "allMemberGroupList"]),
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    queryList() {
      return this.$store.dispatch("queryMemberGroupList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        groupAppellation: this.groupAppellation
      });
    },
    queryAllList() {
      return this.$store.dispatch("queryAllMemberGroupList", {
        pageSize: 99999,
        pageNo: 1
      });
    },
    addGroup() {
      this.$router.push({ name: "AddGroup" });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    edit(row) {
      this.$router.push({
        name: "EditGroup",
        query: {
          groupId: row.groupId
        }
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            const list = this.allMemberGroupList.records;
            list.forEach(v => {
              v.profitValue = `商品专享${v.profitValue}折`;
              if (v.relType == "membercard") {
                v.relType = "会员卡";
              } else {
                v.relType = "会员标签";
              }
            });
            const tHeader = ["群组名称", "关联类型", "身份背景图", "级别权益"];
            const filterVal = [
              "groupAppellation",
              "relType",
              "groupBackgroundImg",
              "profitValue"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "会员群组列表" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped></style>
